import { Component, OnInit } from '@angular/core';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import { AppService } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {
  isGrabitEnable = false;
  grabitUrl: any;
  configuredTailId: any;
  configuredFlightId: any;
  annualFeePopup:boolean = false;
  selectedCountry: string;

  constructor(private appService: AppService, private translateService: TranslateService) {
  }

  ngOnInit() {
    this.configuredTailId = this.translateService.instant('grabit.tailid');
    this.configuredFlightId = this.translateService.instant('grabit.flightnumber');
    this.isGrabitEnable = this.appService.identifyGrabitStatus(this.configuredFlightId, this.configuredTailId);
    this.grabitUrl = ONBOARD_CONSTANTS.GRABIT_URL + this.appService.getDeviceToken();
  }

  showAnnualFeePopup(){
    this.annualFeePopup = true;
  }

  closePopup() {
    this.annualFeePopup = false;
  }

  continue(){
    if(this.selectedCountry==='Norwegian'){
      window.open('https://www.americanexpress.com/no/betalingskort/sas-classic/?cpid=100374654', '_blank');
    }
    else if (this.selectedCountry==='Swedish'){
      window.open('https://www.americanexpress.com/se/kreditkort/sas-eurobonus-classic/?cpid=100374653', '_blank');
    }
    this.annualFeePopup = false;
  }
}
